import React from 'react';
import { ICacheContext } from 'framework/context/ICacheContext';
import { IPatientsFilterData } from 'gen/ApiClient';

export const PatientsFilterDataContext = React.createContext<ICacheContext<IPatientsFilterData>>(undefined as any);
